exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.shorttext[data-v-627af564] {\n    height: 18px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap !important;\n}\n", "", {"version":3,"sources":["D:/a/8/s/AFBPlay/src/components/SideMenu/Promotion/Loyalty.vue"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;CAClC","file":"Loyalty.vue","sourcesContent":["\n.shorttext[data-v-627af564] {\n    height: 18px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-627af564","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SideMenu/Promotion/Loyalty.vue
// module id = d7Oq
// module chunks = 2